import { LinearProgress } from "@mui/material";

interface EnhancedContentLoaderProps {
    updating?: boolean;
}

export default function EnhancedContentLoader({ updating }: EnhancedContentLoaderProps) {
    return (
        <LinearProgress
            style={{
                width: "calc(100% + 2em)",
                height: '0.4em',
                position: "relative",
                top: "-1em",
                right: "1em",
                visibility: updating ? undefined : 'hidden'
            }}
        />
    );
}
